import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#FF001F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/hanayuki.ioco">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Hanayuki Sushi Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/hanayuki.ioco/?utm_source=ig_embed&hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Hanayuki Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FF001F" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/hanayuki.ioco">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Hanayuki Sushi Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/hanayuki.ioco/?utm_source=ig_embed&hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Hanayuki Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
